module.exports = __webpack_public_path__ + "static/way_of_the_four_elements-bfe22ad8c07eff43efd64c9e0b8a307f.png";